<template>
    <div
        class="d-flex align-center"
        :class="{
            'flex-column': orientation === 'column',
            'flex-row': orientation === 'row'
        }"
    >
        <v-row
            v-if="layout === 'card'"
            no-gutters
        >
            <v-col
                v-for="(field, index) in fields"
                :key="`format-${index}`"
                cols="6"
                class="pa-2"
            >
                <StepBtn
                    :image="field.img"
                    :key="`input-options-${index}`"
                    :label="field.label"
                    :sublabel="field.sublabel"
                    :orientation="orientation"
                    :isSelected="selectedValue === field.value"
                    :value="field.value"
                    :layout="layout"
                    :imageOnLeft="true"
                    @select-value="selectValue"
                />
            </v-col>
        </v-row>
        <StepBtn
            v-else
            v-for="(field, index) in fields"
            :key="`input-options-${index}`"
            :image="field.img"
            :label="field.label"
            :sublabel="field.sublabel"
            :orientation="orientation"
            :isSelected="selectedValue === field.value"
            :value="field.value"
            :layout="layout"
            @select-value="selectValue"
        />
    </div>
</template>

<script>
    import StepBtn from '@/components/myHabiteoStudio/steps/components/StepBtn';

    export default {
        name: 'StepBtnGroup',
        components: {
            StepBtn
        },
        props: {
            fields: {
                type: Array,
                required: true
            },
            selectedValue: {
                type: [Number, Boolean],
                required: false
            },
            orientation: {
                type: String,
                required: false
            },
            layout: {
                type: String,
                required: false
            }
        },
        methods: {
            selectValue(val) {
                this.$emit('select-value', val)
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/components/StepBtnGroup.vue